<template>
  <iframe
    id="ai-chat"
    :src="src"
    class="h-[calc(100vh-100px)] w-full tablet:h-[580px]"
  />
</template>

<script setup lang="ts">
const { isProduction } = useSiteContext()

const src = computed(() => {
  const id = isProduction
    ? '649d6f4c8b725442ebaa6faa'
    : '66a8971690fa3c4ae4a369a1'
  return `https://concierge.goodguys.ai/client/${id}/overlay`
})
</script>
